<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import OrderList from './OrderList.vue'
import { getSummaryItemByType, OrderType, OrderTypeSummaryItem } from '../../models/OrderModel'
import { getOrderSummary } from '../../services/orderApi'

const route = useRoute()
const router = useRouter()

function isOrderType(value: unknown): value is OrderType {
  return typeof value === 'string' && (Object.values(OrderType) as string[]).includes(value)
}

const orderSummary = ref<OrderTypeSummaryItem[]>([])

const activeTab = computed<OrderType>({
  get() {
    const q = route.query.type
    const raw = Array.isArray(q) ? q[0] : q

    if (isOrderType(raw)) {
      return raw
    }

    return orderSummary.value[0]?.type ?? OrderType.all
  },

  async set(newType) {
    await router.replace({
      query: {
        ...route.query,
        type: newType,
      },
    })
  },
})

function onTabClick(newType: OrderType) {
  activeTab.value = newType
}

onMounted(() => {
  getOrderSummary().then((parsedOrderSummary) => {
    orderSummary.value = parsedOrderSummary
  })
})
</script>

<template>
  <div>
    <ul v-if="orderSummary" class="nav nav-pills nav-fill mb-12 tabs">
      <li v-for="(tab, index) in orderSummary" :key="index" class="nav-item">
        <button
          class="nav-link"
          :class="activeTab === tab.type ? 'active' : ''"
          @click="onTabClick(tab.type)"
        >
          {{
            `${tab.title || $t(tab.type)} (${getSummaryItemByType(orderSummary, tab.type)?.count || 0})`
          }}
        </button>
      </li>
    </ul>

    <div v-if="orderSummary">
      <template v-for="(tab, index) in orderSummary" :key="index">
        <OrderList v-if="activeTab === tab.type" :type="tab.type" />
      </template>
    </div>
  </div>
</template>
